import { KeyValueRoleModel, KeyValueType } from '@models/common';

export type DocumentActionsData = {
  /** Whether to display the change assignment input */
  hideAssign?: boolean;
  /** Whether to enable the assignment input */
  canAssign?: boolean;
  /** Whether to always show the document number field on actions bar */
  alwaysShowDocNum?: boolean;
  /** Whether to disable the document number field on actions bar. This also means the field will always be shown */
  disableDocNum?: boolean;
  /* TODO: We can bring the assignee on gridFields */
  assignee?: KeyValueRoleModel<string, string>;
  assignOptions?: KeyValueRoleModel<string, string>[];
  disableActions?: boolean;
  disableSubmit?: boolean;
  submitLabel?: string;
  moduleId?: number;
  contractId?: number;
  entityInstanceId?: number;
  documentNumber?: KeyValueType<number>;
  showCancel?: boolean;
  transitionStarted?: boolean;
  disableMoreActions?: boolean;
  formInvalid?: boolean;
};

/** Defaults to be used in DeepComputed.
 * !IMPORTANT: add here all the new properties from DocumentActionsData, if you want to be able to use it in deepComputed
 */
export const DOCUMENT_ACTIONSD_DATA_DEFAULTS: DocumentActionsData = {
  hideAssign: null,
  canAssign: null,
  alwaysShowDocNum: null,
  disableDocNum: null,
  assignee: null,
  assignOptions: null,
  disableActions: null,
  disableSubmit: null,
  submitLabel: null,
  moduleId: null,
  contractId: null,
  entityInstanceId: null,
  documentNumber: null,
  showCancel: null,
  transitionStarted: null,
  disableMoreActions: null,
};
